type EntryPresentation = {
  title: string;
  amountPrefix: '' | '-';
  isFailedOverride?: boolean;
};

type GetEntryPresentationParams = {
  entryType: string | undefined;
  defaultTitle: string;
};

const getDefaultEntryPresentation = (defaultTitle: string): EntryPresentation => ({
  title: defaultTitle,
  amountPrefix: '',
});

const getEntryPresentation = ({
  entryType,
  defaultTitle,
}: GetEntryPresentationParams): EntryPresentation => {
  if (entryType === 'Entries::Checkout') {
    return {
      title: 'Rewards Redeemed',
      amountPrefix: '-',
      isFailedOverride: true,
    };
  }

  if (entryType === 'Entries::Refund') {
    return {
      title: 'Rewards Refunded',
      amountPrefix: '',
    };
  }

  if (entryType === 'Entries::Transfer') {
    return {
      title: 'Donation',
      amountPrefix: '-',
      isFailedOverride: true,
    };
  }

  return getDefaultEntryPresentation(defaultTitle);
};

export { getEntryPresentation, type EntryPresentation };
